<template>
  <div id="adfox_head"></div>
</template>
<script>
import { defineComponent, onMounted, watch } from '@nuxtjs/composition-api';
import { useDevice } from '@/composables/useDevice';

export default defineComponent({
  setup() {
    const { isMobile } = useDevice();
    onMounted(() => {
      watch(
        isMobile,
        () => {
          window.yaContextCb.push(() => {
            window.Ya.adfoxCode.destroy('adfox_head');
            if (isMobile.value) {
              window.Ya.adfoxCode.create({ ownerId: 279233, containerId: 'adfox_head', params: { pp: 'vvq', ps: 'dayh', p2: 'gosj' } });
            } else {
              window.Ya.adfoxCode.create({ ownerId: 279233, containerId: 'adfox_head', params: { pp: 'g', ps: 'dayh', p2: 'gghp' } });
            }
          });
        },
        { immediate: true }
      );
    });
  },
});
</script>
